import script from "./InboxItem.vue?vue&type=script&setup=true&lang=js"
export * from "./InboxItem.vue?vue&type=script&setup=true&lang=js"

import "./InboxItem.vue?vue&type=style&index=0&id=f43edc84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f43edc84"]])

export default __exports__